<template>
    <details v-if="useRdds" class="form details details--box">
        <summary class="summary-wrapper">
            <span>{{ $t("pointsofinterest") }}</span>
            <svg class="icon icon--primary icon--lg not-actionable" tabindex="-1" role="img" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z" fill="currentColor"></path></svg>
        </summary>
        <div class="details__content form-type-checkboxes pthv-form pthv-poi-types-wrapper">
            <div class="form-item form-type-checkbox pthv-poi-type" v-for="poiType in poiTypes">
                <div class="form-input form-input--type-checkbox input-option">
                    <input v-bind="checkboxAttributes(poiType)" :class="['form-checkbox']" v-model="poiTypesChecked" />
                    <div class="after">
                        <svg class="icon icon--primary icon--md not-actionable" tabindex="-1" role="img" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.7071 7.29289C20.0976 7.68342 20.0976 8.31658 19.7071 8.70711L10.7071 17.7071C10.3166 18.0976 9.68342 18.0976 9.29289 17.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929C4.68342 10.9024 5.31658 10.9024 5.70711 11.2929L10 15.5858L18.2929 7.29289C18.6834 6.90237 19.3166 6.90237 19.7071 7.29289Z" fill="currentColor"></path></svg>
                    </div>
                </div>
                <label :for="poiType.tid" class="form-label">{{ poiType.name }}</label>
            </div>
        </div>
    </details>
    <div v-else class="pthv-form pthv-poi-types-wrapper">
        <div class="pthv-poi-type" v-for="poiType in poiTypes">
            <input v-bind="checkboxAttributes(poiType)" v-model="poiTypesChecked" />
            <label :for="poiType.tid">{{ poiType.name }}</label>
        </div>
    </div>
</template>

<script>
    import getPoiTypes from "../lib/poi/getPoiTypes.ts";

    export default {
        name: "ApthPoiTypes",
        inject: ['siteBasePath'],
        created() {
            getPoiTypes(this.siteBasePath, this.network).then(data => {
                this.setPoiTypes(data);
            });
        },
        data() {
            return {
                poiTypes: [],
                poiTypesChecked: []
            };
        },
        watch: {
            // Watch changes on checkboxes and send an event to parent component
            poiTypesChecked(newPoiTypesChecked, oldPoiTypesChecked) {
                this.$emit("selectpoitype", newPoiTypesChecked);
            }
        },
        props: {
            network: {
                type: String,
                required: true
            },
        },
        methods: {
            setPoiTypes: function(poiTypes) {
                this.poiTypes = poiTypes;
                this.$emit("poitypesready", poiTypes);
                this.poiTypesChecked = this.poiTypes.filter((poiType) => {
                    return (poiType.checked == 1);
                }).map((poiType) => {
                    return poiType.tid;
                });
            },
            checkboxAttributes: function(poiType) {
                return {
                    type: "checkbox",
                    title: poiType.name,
                    id: poiType.tid,
                    value: poiType.tid,
                    name: poiType.tid,
                };
            },
        }
    };
</script>

<style>
.pthv-poi-types-wrapper {
    font-weight: bold;
}
.pthv-poi-type {
    margin-block: 0.5rem;
}
</style>
